import type {
  ExtractedDirectoryFilter,
  UsersSearchResultMetadata,
} from './users-search-result-metadata.model';

export interface GenerateUsersSearchResultMetadataOptions {
  readonly vectorQuery: string;
  readonly filters?: ExtractedDirectoryFilter;
  readonly timestamp?: number;
}

export function generateUsersSearchResultMetadata({
  vectorQuery,
  filters,
  timestamp,
}: GenerateUsersSearchResultMetadataOptions): UsersSearchResultMetadata {
  return {
    id: vectorQuery,
    vectorQuery,
    filters: filters ?? {},
    timestamp: timestamp ?? Date.now(),
  };
}
